import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Instagram } from 'lucide-react';
import { messeData } from '../mock';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { t, locale } = useLanguage();
  const dateDisplay = locale === 'en' ? (messeData.datumEn || 'September 19, 2026') : messeData.datum;
  return (
    <footer className="bg-ngbc-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Wordmark with branding */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-3xl font-bold tracking-tight">
                <span className="text-ngbc-accent">Next Gen </span>
                <span className="italic font-normal text-ngbc-mint">Business</span>
                <span className="text-ngbc-accent"> Cup</span>
              </span>
            </Link>
            <p className="text-white/70 mb-4">
              {t('footer.tagline')}
            </p>
            <p className="text-white/70 text-sm">{dateDisplay}</p>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.kontakt')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-ngbc-highlight mt-0.5 flex-shrink-0" />
                <a href={`mailto:${messeData.kontakt.email}`} className="text-white/70 hover:text-ngbc-mint text-sm transition-colors break-all">
                  {messeData.kontakt.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-ngbc-highlight mt-0.5 flex-shrink-0" />
                <span className="text-white/70 text-sm">{messeData.kontakt.telefon}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-ngbc-highlight mt-0.5 flex-shrink-0" />
                <a
                  href="https://maps.app.goo.gl/DcUvCaokXjJygQvQA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-ngbc-mint text-sm transition-colors"
                >
                  {messeData.kontakt.adresse}
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.folgenSie')}</h4>
            <div className="flex flex-wrap gap-4">
              {messeData.socialMedia.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-ngbc-highlight transition-colors border border-white/15"
                  aria-label={social.platform}
                >
                  {social.platform === 'LinkedIn' && <Linkedin className="w-5 h-5" />}
                  {social.platform === 'Instagram' && <Instagram className="w-5 h-5" />}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/70 text-sm">
              {t('footer.copyright')}
            </p>
            <div className="flex space-x-6">
              <Link to="/impressum" className="text-white/70 hover:text-ngbc-mint text-sm transition-colors">
                {t('footer.impressum')}
              </Link>
              <Link to="/datenschutz" className="text-white/70 hover:text-ngbc-mint text-sm transition-colors">
                {t('footer.datenschutz')}
              </Link>
              <Link to="/agb" className="text-white/70 hover:text-ngbc-mint text-sm transition-colors">
                {t('footer.agb')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};